let version = 0;
let controller = new AbortController();
export const authVersion = () => version;
export const authSignal = () => controller.signal;
export const invalidateAdminSession = () => {
  version += 1;
  controller.abort();
  controller = new AbortController();
};
